module.exports = __webpack_public_path__ + "static/media/logo.87a262d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 1892
// module chunks = 0